var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductboard({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#productboard_svg__clip0_5901_40074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.031h8.015l.125-.25V11.43l-.125-.37L0 19.032z",
    fill: "#FEDD77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.016 19.031h8.014l-.225-.537-7.346-7.305-.443-.129v7.971z",
    fill: "#FBAE42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.09l8.015 7.97.204-.412V3.454l-.204-.364H0z",
    fill: "#51BBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.016 3.09v7.97l.49-.23 7.273-7.168.251-.572H8.016z",
    fill: "#139CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.209 10.932l-.24.128 8.014 7.971.158-.355v-7.428l-.158-.188-.172-.128H8.209z",
    fill: "#D13729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.324 10.83l-.34.23v7.97L24 11.06l-.35-.23h-7.325z",
    fill: "#8F2319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.987 3.09l-8.014 7.97h8.014l.158-.464v-7.22l-.158-.286z",
    fill: "#EB5246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.984 3.09v7.97H24l-8.015-7.97z",
    fill: "#AE291D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "productboard_svg__clip0_5901_40074"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 3)",
    d: "M0 0h24v16.031H0z"
  })))));
}

export default SvgProductboard;